/** Side panel layout variant controlling default width. */
export type AncSidePanelVariant = 'forms' | 'details';

/** Default panel widths per variant (Figma Create Order = 1080px forms). */
export const ANC_SIDE_PANEL_DEFAULT_WIDTHS: Readonly<
    Record<AncSidePanelVariant, string>
> = {
    forms: '1080px',
    details: '70vw'
};
